/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const OutdatedCommentsButtonWrapper = styled.div`
  cursor: auto;
  margin-left: ${gridSize()}px;
`;
